import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import { useState, useEffect } from "react";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Works from "./pages/Works";
import ExhibitionDetail from "./pages/ExhibitionDetail";
import Press from "./pages/Press";
import Bio from "./pages/Bio";
import Contact from "./pages/Contact";

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  return (
    <DataProvider>
      <Router>
        <ScrollToTop />
        <div className="bg-white text-black min-h-screen min-h-dvh font-serif">
          <div className="flex min-h-screen min-h-dvh max-w-6xl mx-auto max-lg:w-full max-lg:overflow-x-hidden">
            {/* Mobile Navbar */}
            <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 max-md:block hidden">
              <div className="flex items-center justify-between px-4 py-3">
                <Link
                  to="/"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-lg font-normal tracking-wider no-underline text-black hover:opacity-60 transition-opacity duration-200"
                >
                  NATHAN PORTELLI
                </Link>
                <button
                  onClick={toggleMobileMenu}
                  className="p-2 rounded-md hover:bg-gray-100 transition-colors duration-200"
                  aria-label="Toggle mobile menu"
                >
                  <div className="w-6 h-6 flex flex-col justify-center space-y-1">
                    <span
                      className={`block h-0.5 w-6 bg-black transition-all duration-700 ease-out ${
                        isMobileMenuOpen ? "rotate-45 translate-y-1.5" : ""
                      }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-black transition-all duration-700 ease-out ${
                        isMobileMenuOpen ? "opacity-0" : ""
                      }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-black transition-all duration-700 ease-out ${
                        isMobileMenuOpen ? "-rotate-45 -translate-y-1.5" : ""
                      }`}
                    ></span>
                  </div>
                </button>
              </div>
            </div>

            {/* Sidebar */}
            <div
              className={`w-80 min-w-48 px-10 py-15 border-r border-gray-200 fixed h-screen flex flex-col xl:w-80 lg:w-70 md:w-60 sm:w-48 max-md:fixed max-md:top-0 max-md:left-0 max-md:w-full max-md:h-screen max-md:bg-white max-md:z-40 max-md:transform max-md:transition-all max-md:duration-700 max-md:ease-out max-md:pt-20 ${
                isMobileMenuOpen
                  ? "max-md:translate-x-0"
                  : "max-md:-translate-x-full"
              }`}
            >
              <Link
                to="/"
                className="text-2xl font-normal tracking-wider mb-15 leading-tight max-md:hidden no-underline text-black hover:opacity-60 transition-opacity duration-200 block"
              >
                NATHAN PORTELLI
              </Link>
              <Navigation
                onMobileMenuClose={() => setIsMobileMenuOpen(false)}
              />
            </div>

            {/* Mobile Overlay */}
            {isMobileMenuOpen && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-30 max-md:block hidden"
                onClick={() => setIsMobileMenuOpen(false)}
              ></div>
            )}

            <div className="flex-1 ml-80 py-15 px-15 pl-20 flex flex-col xl:ml-80 lg:ml-70 md:ml-60 max-md:ml-0 max-md:py-10 max-md:px-4 max-md:pt-20 max-md:w-full max-md:overflow-x-hidden max-md:min-h-0">
              <Routes>
                <Route path="/" element={<Bio />} />
                <Route path="/works" element={<Works />} />
                <Route path="/works/:id" element={<ExhibitionDetail />} />
                <Route path="/press" element={<Press />} />
                <Route path="/bio" element={<Bio />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
            </div>
          </div>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
